import { useEffect, useRef } from 'react'
import { useRedactorStore } from '../store/redactorStore'

const DRAFT_KEY = 'redactor_draft'
const DEBOUNCE_MS = 500

export function useDraft() {
  const { inputText, setInputText } = useRedactorStore()
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  // Load draft on mount
  useEffect(() => {
    const saved = localStorage.getItem(DRAFT_KEY)
    if (saved) setInputText(saved)
  }, [setInputText])

  // Save draft with debounce on every change
  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      if (inputText) {
        localStorage.setItem(DRAFT_KEY, inputText)
      } else {
        localStorage.removeItem(DRAFT_KEY)
      }
    }, DEBOUNCE_MS)

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [inputText])

  const clearDraft = () => {
    localStorage.removeItem(DRAFT_KEY)
  }

  return { clearDraft }
}
